import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="25" height="25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M9.5 7.387a.996.996 0 000 1.41l3.88 3.88-3.88 3.88a.996.996 0 101.41 1.41l4.59-4.59a.996.996 0 000-1.41l-4.59-4.59c-.38-.38-1.02-.38-1.41.01z" fill="#07A" /></svg>;